<template>
  <div>
    <div
      v-if="loading"
    >
      <i class="fa fa-fw fa-circle-o-notch fa-spin text-muted"></i>
    </div>
    <a
      v-for="topic in topics"
      :key="topic.id"
      class="card card-category mb-3 text-decoration-none"
      :href="urls.support.showTopic(topic.id, guideType)"
    >
      <span class="card-body media">
        <span class="media-body">
          <span
            class="h5 mb-2 d-block text-flat-peter-river"
            v-html="topic.name"
          ></span>
          <span
            v-if="topic.description"
            class="text-body d-block mb-3"
            v-html="topic.description"
          ></span>
          <hr>
          <div class="">
            <i class="fa fa-fw fa-book text-light-gray mr-2"></i>

          </div>

        </span>
      </span>
    </a>
  </div>
</template>

<script>
import urls from '@/api/urls'
import { getSupportTopics } from '@/api'

export default {
  props: {
    guideType: {
      type: String,
      default: 'guides'
    }
  },
  data () {
    return {
      urls,
      loading: true,
      topics: []
    }
  },
  async mounted () {
    let response = await getSupportTopics(this.guideType)
    this.topics = response.data.topics
    this.loading = false
  }
}
</script>

<!--
<span class="media">
  <span class="media-body">
    <small class="d-block mb-0 text-body">
      {{ topic.guide_count }} {{ topic.guide_count === 1 ? 'guide' : 'guides' }} in this collection
    </small>
  </span>
</span>
-->

<!--
@can('manage-guides')
  <span class="media">
    <span class="media-left profile-img-group align-self-center mr-3">
      <span class="profile-img small border-white border-2">
        <span class="profile-img-body">
          <i class="fa fa-user"></i>
        </span>
      </span>
      @if ($topic->author_count > 1)
        <span class="profile-img small border-white border-2">
          <span class="profile-img-body">
            <i class="fa fa-user"></i>
          </span>
        </span>
      @endif
    </span>
    <span class="media-body align-self-center text-body">
      <small class="d-block mb-0">{{ $guideCount }} {{ str_plural('guide', $guideCount) }} in this collection</small>
      <small class="d-block text-muted">
        Written by
        <span class="text-body font-weight-bold">{{ $topic->authors->first() }}</span>
        @if ($topic->authors->count() > 1)
          and <span class="text-body font-weight-bold">{{ $topic->authors[1] }}</span>
        @endif
      </small>
    </span>
  </span>
@else
  <span class="media">
    <span class="media-body">
      <small class="d-block mb-0 text-body">{{ $guideCount }} {{ str_plural('guide', $guideCount) }} in this collection</small>
    </span>
  </span>
@endcan
-->